import React, { useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import Rank from './Rank';

function Setting(props) {
    return (
        <>
                <div className='pb-5'>
                    <Row className="mx-0 px-0 mt-3 mt-md-0">
                        <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                            <div className="card-white py-4">
                                <div className="py-4">
                                    <Row className="px-0 mx-0">
                                        <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                            <div className='py-3'>
                                                <Rank />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Setting);